import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

/**
 * A validator directive that takes a list to check if a given input is present in the
 * list or not. Raises a validation error if the given input is already in the list.
 */
@Directive({
    selector: '[uniqueEntry]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UniqueEntryValidatorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class UniqueEntryValidatorDirective implements Validator {
  /**
   * The list of values to check the input against.
   */
  @Input('uniqueEntry') list: string[] = [];

  constructor() {}

  /**
   * @param control The control that the Validator will check.
   * @returns Whether or not the value of the control is in the given list, or null if
   * the list length is 0.
   */
  validate(control: AbstractControl): ValidationErrors | null {
    return this.list.length > 0 ? uniqueEntryValidator(this.list)(control) : null;
  }
}

/**
 * @param list The list of values to check the value of the control against.
 * @returns A function that further returns whether or not the value of the control is in the given list.
 */
export function uniqueEntryValidator(list: any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const notUnique = list.includes(control.value);
    return notUnique ? { uniqueEntry: { value: control.value } } : null;
  };
}
